<template>
   <div class="col-sm-12 col-md-4">
      <!-- <div class="card">
         <div class="card-body">
            <h4 class="card-title mb-4">Ventas este año</h4>
            <load-spinner v-if="loading"></load-spinner>
            <div v-else>
               <h2>$34,252</h2>
               <p class="text-muted">This month</p>
            </div>
         </div>
      </div> -->     
   </div>
</template>

<script>
   //import LoadSpinner from '@/components/widgets/LoadSpinner'
   import axios from 'axios'

   export default {
      name: 'Sales-Widget',
      data () {
         return {
            loading: true
         }
      },
      async mounted () {
         let codcli = this.$route.params.codcli
         let coddep = this.$route.params.coddep
         let params = "json="+JSON.stringify({ 'codcli': codcli, 'coddep': coddep })

         await axios({url: 'https://portal.asein.es/api-v2/widget-sales', data: params, method: 'POST' })
         .then(resp => {
            this.details = resp.data
            this.loading = false
         })
         .catch(err => {
            console.log(err)
         })
      },
      //components: { LoadSpinner }
   }
</script>